import React, { createContext } from "react";

const PasteContext = React.createContext({
    pasteImage: undefined,
});

export default PasteContext;
